import React, { useEffect, useState } from 'react';

const useBookingDescription = () => {
  const yearBuiltRegex = /Year Built: (\d{4})/;
  const purchaseDateRegex = /Purchase Date: (\d{4})/;
  const contextRegex = /Context:\s*(.*)/;

  const [description, setDescription] = useState<string>('');
  const [yearBuilt, setYearBuilt] = useState<string>('');
  const [purchaseDate, setPurchaseDate] = useState<string>('');
  const [context, setContext] = useState<string>('');
  const [contextPresent, setContextPresent] = useState<boolean>(false);

  const parseBookingDescription = (selectedBooking: any) => {
    const description = selectedBooking?.description;

    const yearBuiltMatch = description?.match(yearBuiltRegex);
    const purchaseDateMatch = description?.match(purchaseDateRegex);
    const contextMatch = description?.match(contextRegex);

    setYearBuilt(
      yearBuiltMatch && yearBuiltMatch[1] ? yearBuiltMatch[1].trim() : '',
    );
    setPurchaseDate(
      purchaseDateMatch && purchaseDateMatch[1]
        ? purchaseDateMatch[1].trim()
        : '',
    );
    const foundContext =
      contextMatch && contextMatch[1] ? contextMatch[1].trim() : '';
    setContext(contextMatch && contextMatch[1] ? contextMatch[1] : '');

    setContextPresent(!!foundContext);

    setDescription(
      selectedBooking?.description
        ?.replace(yearBuiltRegex, '')
        ?.replace(purchaseDateRegex, '')
        ?.replace(contextRegex, '')
        .trim(),
    );
  };

  return {
    yearBuiltRegex,
    purchaseDateRegex,
    contextRegex,
    contextPresent,
    description,
    yearBuilt,
    purchaseDate,
    context,
    setContext,
    setContextPresent,

    parseBookingDescription,
  };
};

export default useBookingDescription;
